/**
 * A function that returns a comma separated string with optional values of userId and browserCookieId. It's used for
 * the header Correlation-Context value
 */
const calculateClientSideCorrelationContext = (userId?: string | null, browserCookieId?: string) => {
  let correlationContext = browserCookieId ? `browserCookieId=${browserCookieId}` : '';

  if (userId) {
    correlationContext = correlationContext ? `${correlationContext},userId=${userId}` : `userId=${userId}`;
  }

  return correlationContext;
};

export default calculateClientSideCorrelationContext;
